import { LanguageCodes } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const LanguageDictionary: EnumDictionary<LanguageCodes, string> = {
    [LanguageCodes.de]: 'LANGUAGE.GERMAN',
    [LanguageCodes.en]: 'LANGUAGE.ENGLISH',
    [LanguageCodes.fr]: 'LANGUAGE.FRENCH',
    [LanguageCodes.nl]: 'LANGUAGE.DUTCH',
    [LanguageCodes.cs]: 'LANGUAGE.CZECH',
    [LanguageCodes.sk]: 'LANGUAGE.SLOVAK',
    [LanguageCodes.pl]: 'LANGUAGE.POLISH',
    [LanguageCodes.es]: 'LANGUAGE.SPANISH'
};
